"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStudioLiteContext = void 0;
var _react = require("react");
var _AppContext = _interopRequireDefault(require("../../contexts/AppContext"));
var useStudioLiteContext = exports.useStudioLiteContext = function useStudioLiteContext() {
  var appContext = (0, _react.useContext)(_AppContext["default"]);
  var isStudioLite = appContext === null || appContext === void 0 ? void 0 : appContext.isStudioLite;
  if (isStudioLite) return true;
  return false;
};